import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { ProductPlanModel } from 'models/generated/Entities.GormCrm.ProductPlan';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { FormValidationService } from 'services/form-validation.service';
import { NavigationService } from 'services/navigation.service';
import { ProductPlanService } from 'services/productplan.service';

@Component({
	selector: 'edit-product-plan-name',
	templateUrl: './edit-product-plan-name.component.html',
	providers: [FormValidationService],
	imports: [Layout, FormsModule, CustomInputComponent, TranslatePipe]
})
export class EditProductPlanNameComponent {

	private _productPlan!: ProductPlanModel;
	updatedProductPlanName = '';
	
	@Input()
	set productPlan(plan: ProductPlanModel) {
		this._productPlan = plan;
		this.updatedProductPlanName = plan.productName;
	}
	get productPlan() {
		return this._productPlan;
	}

	constructor(private readonly productPlanService: ProductPlanService, private readonly navigation: NavigationService) {}

	saveProductPlan() {
		this.productPlanService.updateProductPlanName(this.productPlan.id!, this.updatedProductPlanName).then(_ => { this.navigation.closeView(this); });
	}
}
